///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/decorators.ts" />
///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/providers/settings.ts" />
namespace TotalContest {
    import IWindowService = angular.IWindowService;
    import IAngularEvent = angular.IAngularEvent;
    import Controller = TotalCore.Common.Controller;
    import SettingsService = TotalCore.Common.Providers.SettingsService;

    interface IVoteCriterion {
        name: string;
    }

    class VoteCriterion implements IVoteCriterion {
        name: string;

        constructor(name) {
            this.name = name;
        }

    }

    @Controller('controllers.totalcontest')
    export class VoteCriteriaCtrl {
        //@PRO
        constructor(private $scope, private $window: IWindowService, private SettingsService: SettingsService) {
            $scope.criteria = this.SettingsService.settings['vote'].criteria;
        }

        add(type: string) {
            let criterion: IVoteCriterion = new VoteCriterion('Untitled');
            this.SettingsService.settings['vote'].criteria.push(criterion);
        }

        remove(index: number, ask: boolean = false, $event: IAngularEvent) {
            if (ask && !this.$window.confirm('Are you sure?')) {
                $event.stopPropagation();
                return false;
            }

            this.SettingsService.settings['vote'].criteria.splice(index, 1);
            return false;
        }
        //@END-PRO
    }

}